<template>
    <div
        v-if="!isBottom"
        class="w-screen bg-gradient-to-r from-white via-white to-blue-100 h-screen fixed top-0 right-0 z-0 flex justify-end"
    >
        <svg
            class="absolute right-0 top-0 h-full w-auto"
            width="274"
            height="1440"
            viewBox="0 0 274 1440"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_1015_867)">
                <g style="mix-blend-mode: multiply">
                    <path
                        d="M98.1806 730.269C-27.7471 228.21 156.301 36.5098 177.289 -262.44C200.968 -270.81 75.2554 -334.66 138.542 -347.44C217.651 -363.41 274.157 -233.33 379.096 -146.61C484.036 -59.8901 403.313 1.71988 450.133 271.01C496.952 540.298 543.771 1224.92 556.687 1489.65C569.602 1754.37 172.446 2163.42 207.964 1926.08C243.482 1688.75 191.039 1100.49 98.1806 730.269Z"
                        fill="#FEF5DE"
                    />
                </g>
                <g style="mix-blend-mode: multiply">
                    <path
                        d="M52.9757 1188.97C-9.01953 1481.08 19.072 1754.17 44.9034 1830.24C57.2809 1904.79 145.646 2051.04 206.349 2096.69C282.229 2153.74 409.771 2121.79 588.976 2071.58C768.181 2021.38 660.012 1788.6 669.699 1672.22C679.385 1555.83 647.096 763.943 650.325 563.119C653.554 362.3 571.217 -144.33 569.602 -158.02C567.988 -171.71 262.855 -477.51 85.265 -461.54C-92.3254 -445.57 -82.0659 -137 72.3493 139.21C333.892 607.036 130.47 823.835 52.9757 1188.97Z"
                        fill="#D5E4F9"
                    />
                </g>
                <g style="mix-blend-mode: multiply">
                    <path
                        d="M172.446 333.189C61.048 604.753 -128 611 148.229 1663.64C209.578 1663.64 234.764 1679.06 277.385 1679.06C330.662 1679.06 408.156 1517.03 438.831 1439.44C469.506 1361.85 543.771 1092.56 550.229 967.049C556.687 841.534 564.759 476.4 576.06 122.68C587.361 -231.05 547 -258.43 475.964 -530C404.928 -801.57 188.59 -609.88 224.108 -402.21C259.626 -194.54 252.859 137.149 172.446 333.189Z"
                        fill="#FEDFDF"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_1015_867">
                    <rect
                        width="1440"
                        height="274"
                        fill="white"
                        transform="translate(0 1440) rotate(-90)"
                    />
                </clipPath>
            </defs>
        </svg>
    </div>
    <div v-else class="fixed bottom-0 left-0 w-full">
        <svg
            viewBox="0 0 1440 274"
            fill="none"
            class="w-full"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g style="mix-blend-mode: multiply">
                <path
                    d="M709.731 98.1806C1211.79 -27.7471 1403.49 156.301 1702.44 177.289C1710.81 200.968 1774.66 75.2554 1787.44 138.542C1803.41 217.651 1673.33 274.157 1586.61 379.096C1499.89 484.036 1438.28 403.313 1168.99 450.133C899.702 496.952 215.075 543.771 -49.6481 556.687C-314.371 569.602 -723.423 172.446 -486.085 207.964C-248.748 243.482 339.512 191.039 709.731 98.1806Z"
                    fill="#FEF5DE"
                />
            </g>
            <g style="mix-blend-mode: multiply">
                <path
                    d="M251.03 52.9757C-41.0777 -9.01952 -314.168 19.072 -390.238 44.9034C-464.786 57.2809 -611.043 145.646 -656.685 206.349C-713.737 282.229 -681.788 409.771 -631.582 588.976C-581.376 768.181 -348.603 660.012 -232.216 669.699C-115.829 679.385 676.057 647.096 876.881 650.325C1077.7 653.554 1584.33 571.217 1598.02 569.602C1611.71 567.988 1917.51 262.855 1901.54 85.265C1885.57 -92.3254 1577 -82.0659 1300.79 72.3493C832.964 333.892 616.165 130.47 251.03 52.9757Z"
                    fill="#D5E4F9"
                />
            </g>
            <g style="mix-blend-mode: multiply">
                <path
                    d="M1106.81 172.446C835.246 61.048 829 -128 -223.645 148.229C-223.645 209.578 -239.062 234.764 -239.062 277.385C-239.062 330.662 -77.0333 408.156 0.557751 438.831C78.1488 469.506 347.436 543.771 472.951 550.229C598.466 556.687 963.6 564.759 1317.32 576.06C1671.05 587.361 1698.43 547 1970 475.964C2241.57 404.928 2049.88 188.59 1842.21 224.108C1634.54 259.626 1302.85 252.859 1106.81 172.446Z"
                    fill="#FEDFDF"
                />
            </g>
        </svg>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
    name: "WavesBg",
    props: {
        position: {
            type: String,
            default: "bottom",
            validator: (val: string) => ["bottom", "right"].includes(val),
        },
    },
    setup(props) {
        const isBottom = computed(() => props.position === "bottom");
        return { isBottom };
    },
});
</script>
